"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveButton = exports.MoveDownButton = exports.MoveUpButton = exports.AddButton = void 0;
const react_1 = __importDefault(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const styled_1 = require("./styled");
const AddButton = ({ onClick, disabled, uiSchema }) => {
    var _a, _b;
    const title = (_a = uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema['ui:options']) === null || _a === void 0 ? void 0 : _a.addTitle;
    const icon = (_b = uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema['ui:options']) === null || _b === void 0 ? void 0 : _b.addIcon;
    const buttonIcon = icon === false ? undefined : react_1.default.createElement(wl_ui_kit_1.Icon, { name: icon !== null && icon !== void 0 ? icon : 'plus' });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(wl_ui_kit_1.Button, { text: title !== null && title !== void 0 ? title : 'Add Item', StartIcon: buttonIcon, onClick: onClick, disabled: disabled, size: "small" })));
};
exports.AddButton = AddButton;
const MoveUpButton = ({ onClick, disabled }) => {
    return (react_1.default.createElement(styled_1.IconWrap, { disabled: disabled },
        react_1.default.createElement(wl_ui_kit_1.IconButton, { onClick: onClick ? (e) => onClick(e) : undefined, disabled: disabled },
            react_1.default.createElement(wl_ui_kit_1.Icon, { name: "arrow_down", style: { transform: 'rotate(180deg)' } }))));
};
exports.MoveUpButton = MoveUpButton;
const MoveDownButton = ({ onClick, disabled }) => {
    return (react_1.default.createElement(styled_1.IconWrap, { disabled: disabled },
        react_1.default.createElement(wl_ui_kit_1.IconButton, { onClick: onClick ? (e) => onClick(e) : undefined, disabled: disabled },
            react_1.default.createElement(wl_ui_kit_1.Icon, { name: "arrow_down" }))));
};
exports.MoveDownButton = MoveDownButton;
const RemoveButton = ({ onClick, disabled, hidden }) => {
    return (react_1.default.createElement(styled_1.IconWrap, { disabled: disabled },
        react_1.default.createElement(wl_ui_kit_1.IconButton, { onClick: onClick ? (e) => onClick(e) : undefined, disabled: disabled },
            react_1.default.createElement(wl_ui_kit_1.Icon, { name: "delete" }))));
};
exports.RemoveButton = RemoveButton;
//# sourceMappingURL=buttons.js.map